import React from "react";
import Reveal from "./Reveal";
import { MARKETS } from "../mock";

export default function Markets() {
  return (
    <section id="markets" style={{ padding: "64px 0", background: "var(--paper-2)", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="section-label">Where we run</div>
              <h2 className="h-section" style={{ marginTop: 18 }}>
                Eight markets live.{" "}
                <span className="serif" style={{ fontSize: "1.05em" }}>One sending desk.</span>
              </h2>
              <p style={{ marginTop: 22, fontSize: 17, lineHeight: 1.6, color: "var(--ink-soft)", maxWidth: 440 }}>
                Finnish and UK companies use Conduit to open markets they don&rsquo;t have a sales team in yet. Each
                market gets its own domains, lists and copy.
              </p>
              <div className="flex items-center gap-6" style={{ marginTop: 26 }}>
                <span className="flex items-center gap-2" style={{ fontSize: 13, color: "var(--ink-soft)" }}>
                  <span style={{ width: 9, height: 9, borderRadius: 99, background: "var(--green)", display: "inline-block" }} /> Campaigns live
                </span>
                <span className="flex items-center gap-2" style={{ fontSize: 13, color: "var(--ink-soft)" }}>
                  <span style={{ width: 9, height: 9, borderRadius: 99, border: "2px solid var(--accent)", display: "inline-block" }} /> Clients based here
                </span>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div style={{ borderTop: "1px solid var(--line-strong)" }}>
              {MARKETS.map((m, i) => {
                const based = m.tag === "Clients based here";
                return (
                  <Reveal key={m.name} delay={i * 55}>
                    <a
                      href="#apply"
                      className="flex items-center justify-between group"
                      style={{ padding: "18px 4px", borderBottom: "1px solid var(--line)", textDecoration: "none", color: "inherit", transition: "padding-left 0.25s ease" }}
                      onMouseEnter={(e) => (e.currentTarget.style.paddingLeft = "16px")}
                      onMouseLeave={(e) => (e.currentTarget.style.paddingLeft = "4px")}
                    >
                      <span className="flex items-center gap-4">
                        <span className="mono" style={{ fontSize: 12, color: "var(--ink-faint)", width: 26 }}>{String(i + 1).padStart(2, "0")}</span>
                        <span style={{ fontSize: "clamp(22px, 3vw, 30px)", fontWeight: 500, letterSpacing: "-0.01em" }}>{m.name}</span>
                      </span>
                      <span className="flex items-center gap-2" style={{ fontSize: 12.5, color: "var(--ink-soft)" }}>
                        <span style={{ width: 8, height: 8, borderRadius: 99, background: based ? "transparent" : "var(--green)", border: based ? "2px solid var(--accent)" : "none", display: "inline-block" }} />
                        {m.tag}
                      </span>
                    </a>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
